/**
 * Navigates to a specific path.
 * @param path - Destination path.
 * @returns Navigation success.
 */
export function navigateToPath(path) {
    window.history.pushState(null, document.title, path);
    return window.dispatchEvent(new PopStateEvent('popstate'));
}
